import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacySnackBarModule } from '@angular/material/legacy-snack-bar';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatStepperModule } from '@angular/material/stepper';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FuseSharedModule } from '@fuse/shared.module';
import { ComponentsModule } from '../../components/components.module';
import { DirectivesModule } from '../../directives/directives.module';
import { CountertopSchemaComponent } from '../countertop-schema/countertop-schema.component';
import { HoleGroupSchemaRendererModule } from '../hole-group-schema-renderer/hole-group-schema-renderer.module';
import { EdgeHoleCoordinatesFormComponent } from './base-point-select/edge-hole-form/edge-hole-coord/edge-hole-coordinates-form.component';
import { EdgeHoleFormComponent } from './base-point-select/edge-hole-form/edge-hole-form.component';
import { FastenerBasePointSelectComponent } from './base-point-select/fastener-base-point-select.component';
import { PlateHoleCoordinatesFormComponent } from './base-point-select/plate-hole-form/plate-hole-coord/plate-hole-coordinates-form.component';
import { PlateHoleFormComponent } from './base-point-select/plate-hole-form/plate-hole-form.component';
import { CountertopFastenerBasePointSelectComponent } from './countertop-base-point-select/countertop-fastener-base-point-select.component';
import { EdgeHoleCoordinatesFormComponent as CountertopEdgeHoleCoordinatesFormComponent } from './countertop-base-point-select/edge-hole-form/edge-hole-coord/edge-hole-coordinates-form.component';
import { EdgeHoleFormComponent as CountertopEdgeHoleFormComponent } from './countertop-base-point-select/edge-hole-form/edge-hole-form.component';
import { PlateHoleCoordinatesFormComponent as CountertopPlateHoleCoordinatesFormComponent } from './countertop-base-point-select/plate-hole-form/plate-hole-coord/plate-hole-coordinates-form.component';
import { PlateHoleFormComponent as CountertopPlateHoleFormComponent } from './countertop-base-point-select/plate-hole-form/plate-hole-form.component';
import { CountertopFastenersWizardDialogComponent } from './countertop-fasteners-wizard-dialog.component';
import { CustomHoleSchemasListComponent } from './fastener-selection/custom-hole-schemas-list/custom-hole-schemas-list.component';
import { FastenerSelectionComponent } from './fastener-selection/fastener-selection.component';
import { FastenersSchemaDialogComponent } from './fastener-selection/fasteners-set-list/fasteners-schema-dialog/fasteners-schema-dialog/fasteners-schema-dialog.component';
import { FastenersSetListComponent } from './fastener-selection/fasteners-set-list/fasteners-set-list.component';
import { FastenerSideSelectComponent } from './fastener-side-select/fastener-side-select.component';
import { FastenersWizardDialogComponent } from './fasteners-wizard-dialog.component';

@NgModule({
  declarations: [
    FastenersWizardDialogComponent,
    CustomHoleSchemasListComponent,
    FastenerBasePointSelectComponent,
    FastenerSideSelectComponent,
    PlateHoleFormComponent,
    EdgeHoleFormComponent,
    PlateHoleCoordinatesFormComponent,
    EdgeHoleCoordinatesFormComponent,
    FastenerSelectionComponent,
    FastenersSetListComponent,
    FastenersSchemaDialogComponent,
    CountertopFastenersWizardDialogComponent,
    CountertopFastenerBasePointSelectComponent,
    CountertopEdgeHoleFormComponent,
    CountertopPlateHoleFormComponent,
    CountertopEdgeHoleCoordinatesFormComponent,
    CountertopPlateHoleCoordinatesFormComponent,
  ],
  imports: [
    MatStepperModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatFormFieldModule,
    MatTableModule,
    MatToolbarModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatDialogModule,
    MatLegacySnackBarModule,

    FuseSharedModule,
    ComponentsModule,
    DirectivesModule,
    HoleGroupSchemaRendererModule,
    CountertopSchemaComponent,
  ],
  exports: [FastenersWizardDialogComponent, CountertopFastenersWizardDialogComponent],
})
export class FastenersWizardDialogModule {}
